import { StyleRulesCallback } from '@material-ui/core/styles/withStyles';

export const styles: StyleRulesCallback<'badgeNotification'> = theme => ({
  badgeNotification: {
    fontWeight: 400,
    height: 15,
    right: -5,
    top: 0,
    width: 15,
  },
  dateMsg: {
    bottom: 3,
    fontSize: 12,
    position: 'absolute',
    right: 0
  },
  fontDefault: {
    color: '#555555',
    fontFamily : `"Roboto", "Helvetica", "Arial", sans-serif`,
    fontWeight: 300,
  },
  itemText: {
    extend: 'fontDefault'
  },
  readyIcon: {
    color: 'green',
    fontSize: 15,
    marginRight: 7,
  },
  readyMsg: {
    extend: 'fontDefault',
    fontSize: 12,
  },
  relative: {
    position: 'relative'
  },
});



// WEBPACK FOOTER //
// ./src/component/shared/layout/notification/styles.tsx